import { Component, OnInit } from '@angular/core';
import { AssignmentService } from '../services/assignment.service';
import { UserService } from '../services/user.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.less']
})

export class TasksComponent implements OnInit {
  getFullYear: number = new Date().getFullYear();
  isCollapsed = false;
  perPage = 10;
  page = 1;
  assignmentData:any=[];
  assignmentContent:any=[];
  isVisible:any;
  createModal = false;
  radioValue = '3';
  pageIndex: number;
  total:string;
  visible = false;
  departmentData:any=[];
  taskDepartment = null;
  taskEmployees = null;
  currentUserId = JSON.parse(localStorage.getItem("currentUser")).user.employee._id;
  taskTitle = '';
  taskNote = '';
  taskContentNote = '';
  taskContentDescription = '';
  taskContentTitle = '';
  taskStartTime = new Date();
  taskStartDate = new Date();
  taskEndTime = new Date();
  taskEndDate = new Date();  
  employeesData:any=[];
  current = 0;
  isAssign:boolean = false;
  assignEmployees:any=[];
  assignTitle = '';
  assignNote = '';
  assignContentNote = '';
  assignContentDescription = '';
  assignContentTitle = '';
  assignStartTime = new Date();
  assignStartDate = new Date();
  assignEndTime = new Date();
  assignEndDate = new Date(); 
  index:number = 1;
  assignmentId:string;

  constructor(
    private assignmentService: AssignmentService,
    private userService: UserService,
    private message: NzMessageService
  ) { }

  ngOnInit() {
    this.assignment();
    this.getDepartment();
  }
  pre(): void {
    this.current -= 1;
    this.changeContent();
  }

  next(): void {
    this.current += 1;
    this.changeContent();
  }

  done(
    taskTitle:string,
    taskNote:string,
    taskDepartment:string,
    taskEmployees:string,
    taskContentTitle:string,
    taskContentDescription:string,
    taskStartTime:any,
    taskStartDate:any,
    taskEndTime:any,
    taskEndDate:any,
    taskContentNote:string    
    ): void {
    var assignment = {
      "department": taskDepartment,
      "note": taskNote,
      "title": taskTitle
    }
    console.log('assignment', assignment);
    this.assignmentService.postAssignment(assignment).subscribe(
      data => {
        console.log('assignment', data);
        var assignmentId = data.data.pt600;
        var assignmentContent = {
          "employee_from": this.currentUserId,
          "employee_to": taskEmployees,
          "assignment": assignmentId,
          "note": taskContentNote,
          "description": taskContentDescription,
          "title": taskContentTitle,
          "start_date": taskStartDate.toLocaleString('fr-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }),
          "end_date": taskEndDate.toLocaleString('fr-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }),
          "start_time": taskStartTime.toLocaleString('vi-VN', { hour: 'numeric', minute: '2-digit' }),
          "end_time": taskEndTime.toLocaleString('vi-VN', { hour: 'numeric', minute: '2-digit' })
        }
        console.log('assignmentContent', assignmentContent);
        this.assignmentService.postAssignmentContent(assignmentContent).subscribe(
          dataContent => {
            this.assignment();
            this.taskTitle = '';
            this.taskNote = '';
            this.taskDepartment = null;
            this.taskEmployees = null;
            this.taskContentTitle = '';
            this.taskContentDescription = '';
            this.taskStartTime = new Date();
            this.taskStartDate = new Date();
            this.taskEndTime = new Date();
            this.taskEndDate = new Date();
            this.taskContentNote = '';
          },
          errorContent => {
            console.log('errorContent', errorContent)
          });
      },
      error => {
        console.log('error', error)
      });
  }



  changeContent(): void {
    switch (this.current) {
      case 0: {
        this.index = 1;
        break;
      }
      case 1: {
        this.index = 2;
        break;
      }
      case 2: {
        this.index = 3;
        break;
      }
      default: {
        this.index = 4;
      }
    }
  }


  assignment(){
    this.pageIndex = 1;
    this.assignmentService.getAssignment(this.perPage, this.page).subscribe((res:any)=>{
      this.assignmentData = res.data.data;
      this.total = this.assignmentData.length;
    });
  }


  showModal(id:string): void {
    this.assignmentId = id;
    console.log('this.assignmentId', this.assignmentId);
    
    this.isAssign = false;
    this.isVisible = id ;
    this.assignmentService.getAssignmentContentId(this.perPage, this.page, id).subscribe((res:any)=>{
      this.assignmentContent = res.data.data;
    });
  }

  handleCancel(): void {
    this.isVisible = false;
    this.createModal = false;
  }

  handleOk(): void {
    this.isVisible = false;
    this.createModal = false;
  }

  handleChangeStatus($event, id:string): void {
    var status = $event;
    this.assignmentService.updateStatus(id, status).subscribe((res:any)=>{});
  }
 
  onPageIndexChange($event) {
    this.assignmentService.getAssignment(this.perPage, $event).subscribe((res:any)=>{
    });
  }
  
  toggle(){
    this.visible = !this.visible;
    console.log('this.visible', this.visible);
  }

  getDepartment(): void {
    this.userService.getAllDepartment().subscribe((res:any)=>{
      this.departmentData = res.data.data;
    })
  }

  handleChangeDepartment(id:string): void{
    if(id == null){
      this.employeesData = [];
      this.taskEmployees = null;
    }else{
      this.userService.getDepartmentId(id).subscribe((res:any)=>{
        this.employeesData = res.data.employees.data;
      });
    }    
  }

  onChange(result: Date): void {
    console.log('onChange: ', result);
  }

  assign(departmentId:string): void {    
    this.isAssign = !this.isAssign;
    if(this.isAssign == true){
      this.userService.getDepartmentId(departmentId).subscribe((res:any)=>{
        this.assignEmployees = res.data.employees.data;
        
      });
    }

  }

  assignSubmit(
    taskEmployees:string,
    assignContentTitle:string,
    assignContentDescription:string,
    assignStartTime:any,
    assignStartDate:any,
    assignEndTime:any,
    assignEndDate:any,
    assignContentNote:string
    ): void {
      var assignContent = {
        "employee_from": this.currentUserId,
        "employee_to": taskEmployees,
        "assignment": this.assignmentId,
        "note": assignContentNote,
        "description": assignContentDescription,
        "title": assignContentTitle,
        "start_date": assignStartDate.toLocaleString('fr-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }),
        "end_date": assignEndDate.toLocaleString('fr-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }),
        "start_time": assignStartTime.toLocaleString('fr-CA', { hour: 'numeric', minute: '2-digit' }),
        "end_time": assignEndTime.toLocaleString('fr-CA', { hour: 'numeric', minute: '2-digit' })
      }
      this.assignmentService.postAssignmentContent(assignContent).subscribe(
        dataAssignContent => {
          this.assignment();
          this.handleCancel();
          this.message.success('Giao việc thành công!');
          this.taskEmployees ='';
          this.assignContentTitle ='';
          this.assignContentDescription ='';
          this.assignStartTime = new Date();
          this.assignStartDate = new Date();
          this.assignEndTime = new Date();
          this.assignEndDate = new Date();
          this.assignContentNote = '';
          
        },
        errorContent => {
          console.log('errorContent', errorContent)
        });
  }

}